/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Location_VirtualInputs */

const en_reference_location_virtual = /** @type {(inputs: Reference_Location_VirtualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual`)
};

/**
* | output |
* | --- |
* | "Virtual" |
*
* @param {Reference_Location_VirtualInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_location_virtual = /** @type {((inputs?: Reference_Location_VirtualInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Location_VirtualInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_location_virtual(inputs)
});